package models

import kotlinx.serialization.Serializable

@Serializable
data class Cast(
    val actors: List<Actor>? = null,
    val id: Int
)

@Serializable
data class Actor(
    val castId: Int?,
    val character: String?,
    val creditId: String?,
    val id: Int,
    val name: String?,
    val originalName: String?,
    val profilePath: String?
)
